import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { CallCenterVolunteer } from "./entity";

const createCustomFilter = createCustomFilterForEntity<CallCenterVolunteer>();

export class CallCenterVolunteerFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<CallCenterVolunteer>
  >((filters) => {
    return filterWithRelationsAndJson(CallCenterVolunteer)(filters);
  });
}
